import { toFixedWithoutRound } from './number';

export function textEllipsis(str: string, index: number) {
  if (str.length <= index) {
    return str;
  }

  const result = str.trim().substring(0, index);

  return result.trim() + '...';
}

/**
 * 값에 따라 금액단위 반환
 * @param value
 * @returns
 */
export function getMoneyUnit(value: number) {
  if (value < 1e8 && value >= 1e4) {
    return '만';
  }

  if (value < 1e12 && value >= 1e8) {
    return '억';
  }

  if (value >= 1e12) {
    return '조';
  }

  return '';
}

/**
 * 값에 따라 만원,억,조 단위 문자열로 변환
 *
 * @param value
 * @param round
 * @param prefix
 * @returns
 */
export function getTransformMoneyUnit(
  value: number,
  round?: boolean,
  prefix: string[] = [],
): string {
  const absoluteValue = Math.abs(value);
  const unit = getMoneyUnit(absoluteValue);
  let divider;

  if (absoluteValue / 1e12 >= 1) {
    divider = 1e12;
  } else if (absoluteValue / 1e8 >= 1) {
    divider = 1e8;
  } else if (absoluteValue / 1e4 >= 1) {
    divider = 1e4;
  } else {
    divider = 1;
  }

  const rest = Math.abs(value % divider);
  const moneyValue = value / divider;

  const validValue = Number(
    Math.sign(moneyValue) * Math.floor(Math.abs(moneyValue)),
  ).toLocaleString();

  prefix.push(`${validValue}${unit}`);

  if (round) {
    return `${toFixedWithoutRound(moneyValue, 1).toLocaleString()}${unit}`;
  }

  if (rest === 0) {
    return `${prefix.join(' ')}`.trim();
  }

  return getTransformMoneyUnit(rest, round, prefix);
}

/**
 * 백분율값 반환
 * @param percentage
 * @param fixed
 * @returns number
 */
export function getPercentage(number: number, fixed: number = 0) {
  const value = number * 100;

  return toFixedWithoutRound(value, fixed);
}
